export const environment: "local" | "dev" | "prod" = "prod";

const BASE_URLS = {
  local: "http://localhost:3000/api",
  dev: "https://dev.api.hollo.ai/api",
  prod: "https://prod.api.hollo.ai/api",
} as const;
export const BASE_URL = BASE_URLS[environment];

const SOCKET_URLS = {
  local: "ws://localhost:3010/chat/ws",
  dev: "wss://dev.ws.hollo.ai/chat/ws",
  prod: "wss://prod.ws.hollo.ai/chat/ws",
} as const;
export const SOCKET_URL = SOCKET_URLS[environment];

export const USERS_BASE_URL = BASE_URL + "/users";
export const MEDIA_BASE_URL = BASE_URL + "/media";
export const AI_BASE_URL = BASE_URL + "/ai";

// Recording Sound Effects
import clickSound from "./assets/sounds/click.mp3";
import cancelSound from "./assets/sounds/cancel.mp3";
import sendSound from "./assets/sounds/send.mp3";

export const RECORD_START_SOUND = clickSound;
export const RECORD_STOP_SOUND = cancelSound;
export const SEND_SOUND = sendSound;
